import ColorScheme from '../ColorScheme/ColorScheme';

const disabledStyles = {
    backgroundDisabled: 'sf-gray-50',
    colorDisabled: 'sf-gray-400',
    borderDisabled: undefined,
    iconColorDisabled: ColorScheme['sf-gray-300']
};

export const DropdownStylesSettings = {
    Default: {
        color: 'sf-primary-800',
        background: 'sf-light-100',
        backgroundHover: 'sf-gray-100',
        backgroundActive: 'sf-light-100',
        border: undefined,
        borderFocus: undefined,
        borderHover: undefined,
        borderActive: undefined,
        borderHoverActive: undefined,
        borderFocusActive: undefined,
        iconColor: ColorScheme['sf-gray-500'],
        ...disabledStyles
    }
};

const DropdownStyles = {
    Default: 'Default'
};

export default DropdownStyles;
